export default function () {
  return this.$imageWidth / this.rotatedInternalImageWidth
}
